module.exports = __webpack_public_path__ + "b379934dfdeb3836bdb20fc0d2e42ff4.svg";